var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyNgn = function SvgIconCurrencyNgn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.788 3.697A1 1 0 0 0 5 4.313V11H3.75a1 1 0 1 0 0 2H5v6.688a1 1 0 0 0 2 0V13h4.512l5.7 7.303A1 1 0 0 0 19 19.688V13h1.25a1 1 0 0 0 0-2H19V4.313a1 1 0 1 0-2 0V11h-4.512zM14.05 13 17 16.781v-3.78zm-4.098-2L7 7.22V11z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyNgn;